<div fxFlex="column" class="assign-lessons">

  <div class="dialog-header">
    {{ title }}
  </div>

  <div [formGroup]="assignLessonsForm" class="assign-lessons-container" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="45">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input formControlName="startDate" matInput [matDatepicker]="startPicker" [min]="todayDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxFlex="45">
        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input formControlName="endDate" matInput [matDatepicker]="endPicker" [min]="assignLessonsForm.controls['startDate'].value">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>


    <div class="assign-container" fxLayout="column">
      <div class="assign-question">
        Assign From Option
      </div>
      <mat-radio-group fxLayout="row" formControlName="assignFromOption" class="assign-selection" aria-label="Select an Option">
        <div fxFlex="45">
          <mat-radio-button [value]="0">
            Curriculum
          </mat-radio-button>
        </div>
        <div fxFlex="45">
          <mat-radio-button [value]="1">
            RTI
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="assign-container mt-10">
      <div fxFlex="45" class="assign-question">
        Remove Extended Response Section :
      </div>
      <div fxFlex="55">
        <mat-slide-toggle formControlName="removeExtended"></mat-slide-toggle>
      </div>
    </div>

    <div class="button-container" fxLayout="row" fxLayoutAlign="space-around center">
      <div>
        <button class="cancel-button button" mat-button type="button" (click)="onCancel()">
          Cancel
        </button>
      </div>
      <div>
        <button [disabled]="!this.assignLessonsForm.valid" class="submit-button button" mat-button type="button" (click)="onAssignConfirm()">
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
